import { useTranslation } from 'react-i18next';
import { trackLanguageChanged } from '../services/firebase';

export type Language = 'pt-BR' | 'en';

export interface LanguageConfig {
  code: Language;
  name: string;
  flag: string;
}

export const AVAILABLE_LANGUAGES: LanguageConfig[] = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' }
];

export const useLanguage = () => {
  const { i18n } = useTranslation();
  
  const currentLanguage = i18n.language as Language;

  const changeLanguage = (newLanguage: Language) => {
    const oldLanguage = currentLanguage;
    i18n.changeLanguage(newLanguage);
    
    // Track language change
    if (oldLanguage !== newLanguage) {
      trackLanguageChanged(oldLanguage === 'pt-BR' ? 'pt' : oldLanguage, newLanguage === 'pt-BR' ? 'pt' : newLanguage);
    }
  };

  return {
    language: currentLanguage,
    changeLanguage,
    isPortuguese: currentLanguage === 'pt-BR',
    isEnglish: currentLanguage === 'en'
  };
};